import React, { useEffect, useState } from "react";
import { PartnerCard } from "../components/PartnerCard";
import { listSlumSoccerPartners } from "../graphql/queries";
import { generateClient } from "aws-amplify/api";

const client = generateClient();

const getPartnerDate = (partner) => {
  try {
    // Check if ef1 exists and is a string before parsing
    const ef1 = typeof partner.ef1 === 'string' 
      ? JSON.parse(partner.ef1) 
      : partner.ef1;
    
    // Parse date, handling potential different formats
    return ef1?.date ? new Date(ef1.date) : new Date(0);
  } catch (error) {
    console.error(`Error parsing date for partner:`, partner);
    return new Date(0);
  }
};

export function Partners(props) {
  const [presentData, setPresentData] = useState([]);
  const [pastData, setPastData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      let pendingData = await client.graphql({
        query: listSlumSoccerPartners,
      });
      
      let allPartners = pendingData["data"]["listSlumSoccerPartners"].items;
      
      // Separate present and past partners
      let presentPartners = allPartners
        .filter((partner) => partner.partnershipType === "present")
        .sort((a, b) => {
          const dateA = getPartnerDate(a);
          const dateB = getPartnerDate(b);
          return dateB - dateA; // Newest first
        });

      let pastPartners = allPartners
        .filter((partner) => partner.partnershipType === "past")
        .sort((a, b) => {
          const dateA = getPartnerDate(a);
          const dateB = getPartnerDate(b);
          return dateB - dateA; // Newest first
        });

      setPresentData(presentPartners);
      setPastData(pastPartners);
    } catch (error) {
      console.error("Error fetching or sorting partners:", error);
    }
  };

  return (
    <>
      <section className="py-16  bg-gradient-to-b from-gray-50 to-gray-100, animate__animated animate__bounceInUp">
        <div className="container mx-auto px-9">
          <div className="text-center mb-5">
            <h2 className="text-4xl font-bold text-orange-500 relative inline-block -mt-10 ">
              Partners
              <div className="h-1 w-full bg-orange-500 mt-2"></div>
            </h2>
            <p className="italic text-lg mt-4 text-white bg-[#efc94c] rounded-xl">
              Slum Soccer has strong working relationships with several domestic
              and international partners and is constantly looking to develop
              new ones. Be it through specific coaching, public relations, or
              management training we aim to continue as a forerunner in sports
              and development initiatives. We are very grateful for their
              association.
            </p>
            <h1 className="mt-5 text-2xl font-bold -mt4">
              Present Partnership
              <hr className="border-4 text-gray-300 my-4" />
            </h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {presentData.map((partner) => (
              <PartnerCard
                key={partner.partnerId}
                title={partner.title}
                imgUrl={partner.imgUrl}
                description={partner.description}
                link={partner.link}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="py-16  bg-gradient-to-b from-gray-50 to-gray-100, animate__animated animate__bounceInUp">
        <div className="container mx-auto px-4">
          <div className="text-center mb-5">
            <h1 className="-mt-3 text-2xl font-bold -mt4">
               Past Partnership
               <hr className="border-4 text-gray-300 my-4" />
             </h1>
          </div>
    
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {pastData.map((partner) => (
              <PartnerCard
                key={partner.partnerId}
                title={partner.title}
                imgUrl={partner.imgUrl}
                description={partner.description}
                link={partner.link}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}